export const BREAKPOINT_QUERIES = {
  Desktop: '(min-width: 1024px)',
  Tablet: '(min-width: 768px) and (max-width: 1024px)',
  Mobile: '(max-width: 767px)',
};
